import { Component, computed, inject, input, output } from '@angular/core';

import { QuestionEditor } from '../../../models/question-editor.model';
import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-list-question-item-wrapper',
  templateUrl: 'list-question-item-wrapper.component.html',
  styleUrls: ['./list-question-item-wrapper.component.scss']
})
export class ListQuestionWrapperComponent {
  activeQuestionId = input<string>();
  question = input<QuestionEditor>();

  activate = output<string>();
  filterComments = output<string>();

  firstInBlock$ = computed(() => {
    // Note: Returned a new instance of the block to trigger computed actions
    const block = this.surveyEditorService.surveyEditor$().blocks.firstInBlock(this.question().id);
    if (!block) {
      return null;
    }

    const parentBlock = this.surveyEditorService.surveyEditor$().blocks.byGroupedBlocksId(block.id);

    if (!parentBlock) {
      return { ...block };
    }

    const isBlockFirstOnParentBlock = parentBlock.groupedBlockIds[0] === block.id;
    return isBlockFirstOnParentBlock ? { ...parentBlock } : null;
  });

  inBlock$ = computed(() => this.surveyEditorService.surveyEditor$().blocks.all.value.find((block) => block.groupedQuestionIds.includes(this.question().id)));
  isFirst$ = computed(() => this.isMoveUpAllowed());
  isLast$ = computed(() => this.isMoveDownAllowed());
  movePositionAllowed$ = computed(() => this.surveyEditorService.surveyEditor$().questions.length > 1);

  private surveyEditorService = inject(SurveyEditorService);

  onActivate(questionId: string): void {
    this.activate.emit(questionId);
    this.filterComments.emit(this.question().code || this.question().id);
  }

  private isMoveUpAllowed(): boolean {
    const isFirstOnSurvey = this.surveyEditorService.surveyEditor$().questions.findIndex((q) => q.id === this.question()?.id) === 0;

    if (!isFirstOnSurvey) {
      return false;
    }

    const isInBlock = this.surveyEditorService.surveyEditor$().blocks.byGroupedQId(this.question()?.id);

    return !isInBlock;
  }

  private isMoveDownAllowed(): boolean {
    const isLastOnSurvey =
      this.surveyEditorService.surveyEditor$().questions.findIndex((q) => q.id === this.question()?.id) ===
      this.surveyEditorService.surveyEditor$().questions.length - 1;

    if (!isLastOnSurvey) {
      return false;
    }

    const isInBlock = this.surveyEditorService.surveyEditor$().blocks.byGroupedQId(this.question()?.id);

    return !isInBlock;
  }
}
